const bytesToMegaBytes = (bytes: number, digits?: number) => {
  const BYTES_PER_KILOBYTE = 1000;
  const BYTES_PER_MEGABYTE = BYTES_PER_KILOBYTE * BYTES_PER_KILOBYTE;
  const result = bytes / BYTES_PER_MEGABYTE;
  return digits ? result.toFixed(digits) : result;
};

export default bytesToMegaBytes;
